import { render, staticRenderFns } from "./confezionamento.vue?vue&type=template&id=2c84531b&"
import script from "./confezionamento.vue?vue&type=script&lang=js&"
export * from "./confezionamento.vue?vue&type=script&lang=js&"
import style0 from "./confezionamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports